<template>
  <v-form novalidate ref="form" v-model="valid" lazy-validation>
    <v-text-field
      v-model="username"
      :rules="emailRules"
      label="Utilizador"
      required
      filled
      append-icon="mdi-account-check"
      :disabled="getDisabledButton"
    ></v-text-field>

    <v-text-field
      v-model="pwd"
      :rules="pwdRules"
      label="Palavra-passe"
      required
      filled
      :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
      @click:append="() => (value = !value)"
      :type="value ? 'password' : 'text'"
      :disabled="getDisabledButton"
    ></v-text-field>
    <input type="hidden" name="browser" value="" />
    <input type="hidden" name="ip" value="" />
    <v-card-actions>
      <!--            <submit-button :valid="valid"></submit-button>-->
      <v-btn
        color="deep-purple lighten-2"
        text
        block
        @click="submitLogin"
        :disabled="!valid"
        :loading="getLoadingSpin"
      >
        Iniciar sessão
      </v-btn>
    </v-card-actions>
  </v-form>
</template>
<script>
import { mapHelper } from "@/store/helper";
import takeIp from "../../../services/takeIp";
export default {
  name: "FormLogin",
  data: () => ({
    value: true,
    valid: true,
    access: true,
    pwd: "",
    browser: "",
    pwdRules: [
      v => !!v || "Palavra-passe é requerida",
      v => (v && v.length >= 6) || "Deve ter no mínimo 6 caracter",
      v =>
        /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W+)(?=^.{6,15}$).*$/.test(v) ||
        "Deve ter minúsculas, maísculas e caracter especial"
    ],
    username: "",
    emailRules: [
      v => !!v || "Utilizador é requerido",
      v => /.+@.+\..+/.test(v) || "Utilizador inválido"
    ]
  }),
  methods: {
    submitLogin() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("login", {
          email: this.username,
          password: this.pwd,
          browser: this.$store.getters.getYourBrowser,
          ip: this.$store.getters.getYourIp
        });
      }
    },
    sleep: function(m) {
      return new Promise(resolve => setTimeout(resolve, m));
    },
    close() {
      return (this.errorLogin = false);
    }
  },
  mounted() {
    takeIp.getIpFromAmazon();
    takeIp.getNameBrowser();
  },
  computed: {
    ...mapHelper
  }
};
</script>

<style scoped></style>
